import { useEffect, useRef } from 'react';
import moment from 'moment';
import queryString from 'query-string';
import { redirect, useLocation } from 'react-router-dom';
import { ContentTitle } from '../../components/typography/Heading';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import { useProject } from '../project-hooks/useProject';
import { useSelector } from 'react-redux';
import { getUpdatesForProjectId } from '../project-update-reducer';
import { isMobile } from '../../utils';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import { eligibleToPromoteProjectActivityFeed } from '../project-model';
import { getStatsForRecentTransactionsForProject } from '../projects-reducer';
import { useFeature } from '../../components/hooks/isFeatureEnabled';
import { STREAM_ON_PROJECT } from '../../constants/features/constants';
import { PROJECT_UPDATES_QUERY_NAME } from './ProjectUpdatesModal';
import ProjectUpdateList from './ProjectUpdateList';
import styles from './project-update.module.less';
import I18nText from '../i18n/I18nText';
import { BACK_TO_PROJECT_TEXT_KEY, UPDATES_TEXT_KEY } from '../i18n/project-i18n-model';

const ProjectUpdateListShow = ({ className }) => {
    const userAgent = useSelector((state) => state.userAgent);
    const project = useProject();
    const projectId = project.id;
    const location = useLocation();
    const projectUpdates = useSelector((state) => getUpdatesForProjectId(state, projectId));
    const recentTransactionStats = useSelector((state) => getStatsForRecentTransactionsForProject(state, projectId));
    const streamOnProject = useFeature(STREAM_ON_PROJECT);
    const shouldScroll = queryString.parse(location.search)?.scroll === 'true';
    projectUpdates.sort((a, b) => moment(b.created_at).valueOf() - moment(a.created_at).valueOf());
    const containerElement = useRef(null);
    const showBackNavigation = eligibleToPromoteProjectActivityFeed({
        numberOfRecentTransactions: recentTransactionStats?.numberOfRecentTransactions || 0,
        streamOnProject,
        project,
        userAgent,
    });

    useEffect(() => {
        shouldScroll && containerElement.current.scrollIntoView({ block: 'start' });
    }, [shouldScroll]);

    useEffect(() => {
        projectId && trackPageView({ urlAsEvent: 'project-update', properties: { 'project-id': projectId } });
    }, [projectId]);

    return (
        <div ref={containerElement} className={className}>
            {showBackNavigation && (
                <TrackEventLink
                    category={'project-update-back'}
                    action={'click'}
                    className={styles.backToProjectLink}
                    to={`/project/${project.id}`}
                    preventScrollReset={true}
                >
                    ← <I18nText textKey={BACK_TO_PROJECT_TEXT_KEY} />
                </TrackEventLink>
            )}
            <ContentTitle tag={'h2'}>
                <I18nText textKey={UPDATES_TEXT_KEY} />
            </ContentTitle>
            <ProjectUpdateList />
        </div>
    );
};

export const loader = async ({ getState, params }) => {
    const state = getState();
    const showProjectUpdatesModal = isMobile(state.userAgent);
    if (showProjectUpdatesModal) {
        return redirect(`/project/${params.projectId}?${PROJECT_UPDATES_QUERY_NAME}=true`);
    }
};

export default ProjectUpdateListShow;
